import { createFileRoute } from '@tanstack/react-router';
import { DetalheDaAssinatura } from '@/features/pagamentos/componentes/DetalheDaAssinatura';
import { rotaDeTela } from '@/features/permissoes/guardas';

/** Detalhe da assinatura (spec 013, CA-16 a CA-19). */
export const Route = createFileRoute('/_autenticado/pagamentos/$id')({
  ...rotaDeTela('pagamentos.assinaturas'),
  component: Pagina,
});

function Pagina() {
  const { id } = Route.useParams();
  return <DetalheDaAssinatura key={id} id={id} />;
}
